import { InspirationalCardsList } from './inspirational-cards';
import { HEADLINE, TEXT_CONTENT } from './inspirational-cards-section-data';
import { Container, Title, Text } from './inspirational-cards-section.styles';

export const InspirationalCardsSection: React.FC = () => (
  <Container>
    <Title size="xxlarge">{HEADLINE}</Title>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text size="xlarge" dangerouslySetInnerHTML={{ __html: TEXT_CONTENT }} />
    <InspirationalCardsList />
  </Container>
);
